export const SLPVoiceLang = {
    err: 'خطایی در آپلود صدا رخ داده است,لطفا دوباره تلاش نمایید',
    noUploadErr: 'لطفا فایل را ارسال کنید',
    noPermission: 'اجازه ضبط صدا برای پاسخ به سوال داده نشد.',
};
